var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, Tooltip } from 'shared/components';
import { useFlagEnabled } from 'src/flagging/hooks';
import { Undo } from 'src/shared/assets/icons';
import { TourFlag, TourTooltip, useTour } from 'shared/features/tour';
import { useUndoTimerContext } from '../contexts';
import { useEffect, useMemo } from 'react';
export var UndoButton = function (_a) {
    var disclosure = _a.disclosure;
    var canUndo = useUndoTimerContext().canUndo;
    var _b = useTour(), complete = _b.complete, activeFlags = _b.activeFlags;
    var flagEnabled = useFlagEnabled('UNDO_NOTE');
    useEffect(function () {
        if (flagEnabled && !canUndo && activeFlags.includes(TourFlag.undoNote)) {
            // Turn off tour tooltip if time expires
            complete(TourFlag.undoNote, false);
        }
    }, [canUndo, flagEnabled]);
    var onClick = function () {
        complete(TourFlag.undoNote, false);
        disclosure.onOpen();
    };
    var TooltipComponent = useMemo(function () { return (canUndo ? UndoTourTooltip : DisabledTooltip); }, [canUndo]);
    if (!flagEnabled) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(TooltipComponent, { children: _jsx(Button, __assign({ "data-testid": "undoNotesButton", color: "green.500", leftIcon: _jsx(Undo, {}), variant: "links", disabled: !canUndo, onClick: onClick, _disabled: {
                opacity: 1,
                color: 'gray.400',
            }, _hover: {
                _disabled: {
                    cursor: 'not-allowed',
                },
            } }, { children: "Undo Note" })) }));
};
var UndoTourTooltip = function (_a) {
    var children = _a.children;
    return (_jsx(TourTooltip, __assign({ tourFlag: TourFlag.undoNote, label: "You can now undo a note up to 1 hour after signing.", placement: "top", maxW: "3xs" }, { children: children })));
};
var DisabledTooltip = function (_a) {
    var children = _a.children;
    return (_jsx(Tooltip, __assign({ label: "A note can only be undone for one hour after it has been signed.", placement: "top", hasArrow: true, maxW: "3xs" }, { children: _jsx(Box, { children: children }) })));
};
